import { Navigate, useParams } from 'react-router-dom';
import Loader from 'ui-component/Loader';
import { isHiddenForRoles } from 'utils/managerRoles';
import currentUserRole from 'utils/currentUserRole';
import { useFeatureEnabled, useFeatureListLoaded } from 'utils/supportedFeatures';
import administrationDefaultPath from './administrationDefaultPath';

/**
 * Blocks Users/Reports routes when the menu would hide them (manager role or feature 299).
 */
export default function RoleFeatureGate({ hiddenForRoles, featureId, children }) {
  const { orgName } = useParams();
  const featureListLoaded = useFeatureListLoaded();
  const featureEnabled = useFeatureEnabled(featureId);

  if (isHiddenForRoles(hiddenForRoles, currentUserRole())) {
    return <Navigate to={administrationDefaultPath(orgName)} replace />;
  }

  if (featureId != null && featureId !== '') {
    if (!featureListLoaded) {
      return <Loader />;
    }
    if (!featureEnabled) {
      return <Navigate to={administrationDefaultPath(orgName)} replace />;
    }
  }

  return children;
}
